const botEmbedApiResponse = {
  status: 1,
  msg: "Bot embed details fetched successfully",
  statusCode: 200,
  success: true,
  timestamp: "2026-05-28T14:32:29.466Z",
  data: [
    {
      id: 480,
      setting_id: "f06ae4f3-48e0-4024-a769-b45813620401",
      bot_id: "0acd2d80-21a8-483b-b68b-108984e9297b",
      chat_bbl_desc: "",
      tone: "Simple",
      language: "English",
      fontHeader: "Small",
      fontBody: "Arial",
      responseLength: null,
      is_deleted: 0,
      createdAt: "2026-05-22T05:37:42.000Z",
      filetype: null,
      slugs:
        "https://coolbiz-clone-s3.s3.us-east-1.amazonaws.com/public/chat.png",
      domain_link: "https://www.bottbuddy.com/bot-test",
      description_icon:
        "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava1-bg.webp",
      widget: 1,
      width: 450,
      height: 550,
      original_x: 1920,
      original_y: 927,
      viewport_x: 1781,
      viewport_y: 841,
      desc_box_x: 1601,
      desc_box_y: 781,
      chat_box_x: 1391,
      chat_box_y: 351,
      isDescAllow: 0,
      openRouterModel: "gpt-4o-mini",
      ppLink_value: "",
      ppLink_type: "url",
      tmsLink_value: "",
      tmsLink_type: "url",
      bot_possition: "custom",
      desc_height: "undefined",
      show_default: 1,
      answer_from_general: 0,
      human_takeover_attempt: 1,
      wp_group: 0,
      message_per_session: 50,
      is_message_per_session: 0,
      bot_name: "approlab bot bm",
      user_uuid: "84cd1aca-3e0c-4d8d-95b2-50a9c77446da",
      template_name: "template#2",
      template_id: 2,
      styles: {
        page_bg: "#f8e71cff",
        btn_color: "#A1CBFA",
        footer_bg: "#E6EDF2",
        header_bg: "#92f81eff",
        icon_color: "#4469D2",
        link_color: "#265EA8",
        input_color: "#040E16",
        bot_tb_color: "#0b952bff",
        bot_txt_color: "#000000ff",
        btn_txt_color: "#020619",
        input_box_color: "#ffffff",
        option_tb_color: "#1D59A6",
        option_txt_color: "#ffffff",
        sender_tb_color: "#2fc1c1ff",
        sender_txt_color: "#000000",
        bot_border_color: "#C1D3EE",
        sender_border_color: "#C1D3EE",
      },
      status: 1,
      updatedAt: "2026-05-22T06:45:47.000Z",
      step: 1,
      html_content: "<html></html>",
      bot_image:
        "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava1-bg.webp",
      parentId: 21,
      userId: 21,
      userType: 1,
      fullName: "bottbuddy Admin",
      firstName: "bottbuddy",
      lastName: "Admin",
      organizationName: "BottBuddy",
      stone: null,
      slanguage: null,
    },
  ],
};

export const DEFAULT_BOT_WIDGET_IMAGE =
  "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava1-bg.webp";
export const DEFAULT_DESCRIPTION_ICON =
  "https://8571216.fs1.hubspotusercontent-na1.net/hub/8571216/hubfs/jane.png?width=108&height=108";
export const DEFAULT_BOT_LAUNCHER_ICON =
  "https://coolbiz-clone-s3.s3.us-east-1.amazonaws.com/public/speech-bubble.png";
const defaultStyles = botEmbedApiResponse.data[0].styles;
const defaultRecord = botEmbedApiResponse.data[0];

const resolveImageUrl = (value, fallback) => {
  if (typeof value === "string") {
    const normalizedValue = value.trim();
    return normalizedValue || fallback;
  }

  return value || fallback;
};

const createTranscript = () => [];

const createQuickActions = (organizationName) => [
  // { id: "tour", label: "Book a demo" },
  // { id: "pricing", label: "View pricing" },
  // { id: "support", label: `Contact ${organizationName}` },
];

export const extractBotId = (value = "") => {
  const normalizedValue = String(value || "").trim();

  if (!normalizedValue) {
    return "";
  }

  try {
    const parsedUrl = new URL(normalizedValue);
    return parsedUrl.searchParams.get("id") || normalizedValue;
  } catch (error) {
    if (normalizedValue.includes("?id=")) {
      return normalizedValue.split("?id=").pop()?.trim() || "";
    }

    return normalizedValue;
  }
};

export const normalizeBotEmbedConfig = (record = {}, botId = "") => {
  const mergedRecord = {
    ...defaultRecord,
    ...record,
    styles: {
      ...defaultStyles,
      ...(record?.styles || {}),
    },
  };

  const resolvedBotId =
    extractBotId(botId) ||
    extractBotId(mergedRecord.setting_id) ||
    extractBotId(mergedRecord.bot_id);
  const resolvedBotName = mergedRecord.bot_name || defaultRecord.bot_name;

  return {
    ...mergedRecord,
    bot_image: resolveImageUrl(
      mergedRecord.bot_image,
      DEFAULT_BOT_WIDGET_IMAGE,
    ),
    description_icon: resolveImageUrl(
      mergedRecord.description_icon,
      DEFAULT_DESCRIPTION_ICON,
    ),
    setting_id: resolvedBotId || mergedRecord.setting_id,
    bot_name: resolvedBotName,
    organizationName:
      mergedRecord.organizationName || defaultRecord.organizationName,
    transcript: createTranscript(resolvedBotName),
    quickActions: createQuickActions(
      mergedRecord.organizationName || defaultRecord.organizationName,
    ),
  };
};

export const getBotEmbedMock = (botId) =>
  normalizeBotEmbedConfig(defaultRecord, botId);

export default botEmbedApiResponse;
